<!--  -->
<template>
<div class='' style="width:100%;height:100%;">
<Nav :navList="navList"></Nav>
    <div id="bg">
      <img src="@/assets/发展历史.png"/>
      <img src="@/assets/透明猪.png"/>
    </div>

  <div  style="width:100%;height:100%;position: relative;">
    <div id="history" v-if="historyData==undefined||historyData.length==0">
        <span style="font-size:25px;color:brown;text-align:left">{{ message }}</span>
    </div>
    <div v-else id="history">
      <div id="date" v-for="item in historyData" :key="item"  style="">
        <h1>{{item.year}}</h1>
        <h3>{{item.event}}</h3>
      </div>  
    </div>
  </div>

</div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Nav from '@/components/Nav'
import {queryHistory} from '@/api/web/company'
import {loadingTime} from '@/utils/const.js'
export default {
//import引入的组件需要注入到对象中才能使用
components: {Nav},
data() {
//这里存放数据
return {
navList:['发展历史,/introduction/history','公司简介,/introduction/index','门店分布,/introduction/distribution','门店展示,/introduction/show'],
nums:6,
historyData:[],
message:"小猪班纳历史信息加载中......"
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {

},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
  var _this = this
  setTimeout(()=>{
    if(_this.historyData==undefined||_this.historyData.length==0){
      _this.message="小猪班纳历史信息加载失败,请刷新页面重试"
    }
  },loadingTime)
  queryHistory().then(({data})=>{
    _this.historyData = data
  },()=>{
    _this.message="小猪班纳历史信息加载失败,请刷新页面重试"
  })
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>

#bg img{
  position: relative;
}
#bg{
  position:fixed;
  width:100%;
  height:100%;

}
#bg img:first-child{
  top:50%;
  left:7%;
  width:15%;
  height:30%;
  z-index: 10;
  
  @media screen and (max-width: 768px) {
    width: 25%;
    height: 20%;
    left: 5%;
    top: 55%;
  }
}

#bg img:last-child{
  top:55%;
  left:50%;
  width:30%;
  height:45%;
  z-index: 10;
  
  @media screen and (max-width: 768px) {
    width: 40%;
    height: 30%;
    left: 30%;
    top: 60%;
  }
}

#date{
  text-align:center;
  width:12%;
  height:auto;
  margin-left:8%;
  display:flex;
  flex-direction: column;
  justify-content: flex-start;
  
  @media screen and (max-width: 1024px) and (min-width: 769px) {
    width: 20%;
    margin-left: 5%;
  }
  
  @media screen and (max-width: 768px) {
    width: 40%;
    margin-left: 5%;
    margin-bottom: 20px;
  }
}

#date h1{
  border-bottom: 1px solid black;
  padding-bottom:8px;
  text-align: left;
  font-size: 40px;
  
  @media screen and (max-width: 1024px) and (min-width: 769px) {
    font-size: 32px;
  }
  
  @media screen and (max-width: 768px) {
    font-size: 24px;
  }
}

#date h3{
  text-align: left;
  text-align: justify;
  font-size: 20px;
  margin-top:-10px;
  
  @media screen and (max-width: 1024px) and (min-width: 769px) {
    font-size: 16px;
  }
  
  @media screen and (max-width: 768px) {
    font-size: 14px;
  }
}

#history{
  width:60%;
  height:auto;
  // overflow-y:visible;
  position:absolute;
  z-index:100;
  left:25%;
  top:100px;
  margin-bottom: 30px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  
  @media screen and (max-width: 1024px) and (min-width: 769px) {
    width: 70%;
    left: 20%;
    top: 80px;
  }
  
  @media screen and (max-width: 768px) {
    width: 95%;
    left: 2.5%;
    top: 60px;
  }
}

</style>